import { AbstractControl, ValidatorFn } from '@angular/forms';
import { InputValidationErrors } from '@libs/form/models';
import { DateTime } from 'luxon';

export class DatetimeValidator {
  public static minDate(min: string): ValidatorFn {
    return (control: AbstractControl): InputValidationErrors | null => {
      const value: DateTime = control.value as DateTime;
      const minDate: DateTime = DateTime.fromISO(min);

      if (!value) {
        return null;
      }

      if (!minDate.isValid) {
        console.error('minimum date is not a valid iso date');

        return null;
      }

      if (!value.isValid || minDate <= value) {
        return null;
      }

      return {
        minDate: true,
      };
    };
  }

  public static maxDate(max: string): ValidatorFn {
    return (control: AbstractControl): InputValidationErrors | null => {
      const value: DateTime = control.value as DateTime;
      const maxDate: DateTime = DateTime.fromISO(max);

      if (!value) {
        return null;
      }

      if (!maxDate.isValid) {
        console.error('maximum date is not a valid iso date');

        return null;
      }

      if (!value.isValid || maxDate >= value) {
        return null;
      }

      return {
        maxDate: true,
      };
    };
  }
}
